import { render, staticRenderFns } from "./telephoneBill.vue?vue&type=template&id=18423f7f"
import script from "./telephoneBill.vue?vue&type=script&lang=js"
export * from "./telephoneBill.vue?vue&type=script&lang=js"
import style0 from "./telephoneBill.vue?vue&type=style&index=0&id=18423f7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports